export default __webpack_public_path__ + "static/1.2-Text-alternatives-DONT_4-8f7a277fb883fd4ab6171d479911daf9.png";